import {Fragment, useEffect, useState} from "react";
import {get, handleApiError, post} from "../js/api";
import {useHistory} from "react-router";
import {markDirty, showError, showMessage} from "../js/main";
import {BreadCrumb} from "./Breadcrumb";
import {Button} from "./form/Button";
import {InputText} from "./form/InputText";
import {OrderInformation} from "./OrderInformation";
import {getOwnUser} from "../controller/Profile";


export const UpdateOrderComponent = ({identifier, token = false}) => {

    const [prefix, setPrefix] = useState('');
    const [selectedOrder, setSelectedOrder] = useState();
    const [signatureCode, setSignatureCode] = useState();

    const [submitting, setSubmitting] = useState(false);
    const [canCancel, setCanCancel] = useState(true);
    const [canSign, setCanSign] = useState(true);

    useEffect(() => {
        let prefix = ''
        if(token){
            prefix = '/public';
            setPrefix(prefix);
        }
        get(`${prefix}/orders/${identifier}`).then((data) => {
            setSelectedOrder(data);
        })

    }, [identifier, token]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if(!selectedOrder){
            return;
        }
        if(!token){
            getOwnUser().then((user) => {
                if(selectedOrder.username && selectedOrder.username.toLowerCase() == user.username.toLowerCase()){
                    setCanSign(true);
                    setCanCancel(["CREATED", "AWAIT_PAYMENT"].indexOf(selectedOrder.state) != -1);
                }else{
                    setCanSign(false);
                    setCanCancel(false);
                }
            });
        } else {
            setCanSign(true);
            setCanCancel(["CREATED", "AWAIT_PAYMENT"].indexOf(selectedOrder.state) != -1);
        }
    },[selectedOrder, token])

    const history = useHistory();

    const signOrder = () => {
        setSubmitting(true);

        const req = {
            tan: signatureCode
        };

        post(`${prefix}/orders/${selectedOrder.id}/signOrder`, req, false).then((resp) => {
            markDirty();
            showMessage("Die Bestellung wurde erfolgreich bestätigt.");
            if(!token){
                history.push("/meine-bestellungen");
            }else{
                setSelectedOrder(resp);
            }
        }).catch(err => {
            setSignatureCode("");
            let msg = "Der eingegebene Code war nicht korrekt.";
            if (err.response.data) {
                switch (err.response.data.errorType) {
                    case "RETRY":
                        msg += "Bitte versuchen Sie es erneut.";
                        break;
                    case "FAIL":
                        msg += "Die Bestellung wurde storniert.";
                        history.push("/meine-bestellungen");
                        break;
                    default:
                        break;
                }
                showError(msg);
                return;
            }
            handleApiError(err);
        }).finally(() => {
            setSubmitting(false);
        });
    };

    const requestNewTan = () => {
        setSubmitting(true);
        post(`${prefix}/orders/${selectedOrder.id}/requestNewTan`).then(() => {
            showMessage("Neuer Code wurde erfolgreich versendet.");
        }).finally(() => {
            setSubmitting(false);
        });
    };

    const cancelOrder = () => {
        setSubmitting(true);
        post(`${prefix}/orders/${selectedOrder.id}/cancelOrder`).then(() => {
            markDirty();
            showMessage("Die Bestellung wurde erfolgreich storniert.");
            history.push("/bestellungen");
        }).finally(() => {
            setSubmitting(false);
        });
    };

    return (
        <Fragment>
            {selectedOrder &&
                <div>
                    <BreadCrumb currentTitle={"Bestellung " + selectedOrder.id} parentTitle={token ? '' : "Meine Bestellungen"} parentLink={token ? '' : "/meine-bestellungen"}/>

                    {selectedOrder.state === "CREATED" &&
                        <div className="zeichnung mt-5 mb-5">
                            <h2 className="primary-link mt-0">Bestellung autorisieren</h2>
                            {canSign && <>
                                <p>
                                    <strong>Sie haben den Bestätigungscode per Mail erhalten. Überprüfen Sie Ihren
                                        Spam-Ordner!</strong> Mit Eingabe des
                                    Codes wird die Bestellung abgeschickt, Sie stimmen damit unseren AGB zu und es wird ein
                                    rechtsgültiges Geschäft
                                    abgeschlossen. Der Code besteht nur aus Zahlen.<br/>
                                </p>
                                <form onSubmit={event => {
                                    event.preventDefault();
                                    signOrder();
                                }}>
                                    <InputText required label="Code" name="tan" value={signatureCode}
                                               setter={newValue => setSignatureCode(newValue)}/>
                                    <p>
                                        <small>
                                            <b className={"yellow"}>Ich bestätige hiermit,</b> dass ich berechtigt bin, den/die bestellen Schlüssel
                                            nachmachen zu lassen. <br/>
                                            Mir/uns ist bewusst, dass falsche Angaben rechtliche Schritte bzw. auch
                                            strafrechtliche Konsequenzen nach sich ziehen können. Ich verpflichte
                                            mich jeden Schaden bzw. Nachteil zu ersetzen, der aus einer falschen Angabe
                                            bzw. aus falschen Beilagen bzw. aus falschen Informationen resultieren,
                                            entstehen. <br/>
                                            <b className={"yellow"}>Mit der Eingabe des Freigabe - Codes erkläre ich mich damit einverstanden,</b> dass die angegeben Daten, inkl. möglicher Dokument-Kopien sowie der übermittelten Fotos im Sinne der DSGVO zur Bestellung eines Schlüssels herangezogen werden und dieser zur Anfertigung des/der Schlüssel/s verwendet werden oder an den Erzeuger zur Bestellung weitergegeben werden.
                                        </small>
                                    </p>
                                    <Button submitting={submitting} width={220} theme="green mr-1">Bestellung
                                        bestätigen</Button>
                                    <Button submitting={submitting} width={230} type="button"
                                            onClick={() => requestNewTan()}
                                            theme="orange">Neuen Code anfordern</Button>
                                </form>
                            </>}
                            {!canSign && <>
                                <p>
                                    <strong>Die Bestellung kann nur vom Ersteller bestätigt werden.</strong>
                                </p>
                            </>}

                        </div>}

                    <OrderInformation order={selectedOrder} showUser/>

                    {canCancel && <form onSubmit={e => {
                        e.preventDefault();
                    }} className="storno mt-3 ">
                        <h3 className="red mt-0">Bestellung stornieren</h3>
                        <p>
                            Wenn Sie die Bestellung stornieren, kann das nicht mehr widerrufen werden. Wenn Sie die
                            Bestellung später dennoch
                            durchführen wollen, muss eine neue Bestellung erstellt werden. Nach der Zeichnung kann die
                            Bestellung nur mehr von
                            Mitarbeitern der Lintner GmbH storniert werden. Setzen Sie sich hierfür bei Bedarf mit dem
                            Kundenservice in
                            Kontakt.
                        </p>
                        <Button submitting={submitting} width={230} theme="red" onClick={() => cancelOrder()}>Bestellung
                            stornieren</Button>
                    </form>}

                    <br/><br/>
                </div>}
        </Fragment>
    );

};